const DISABLED_VALUES = new Set(["", "0", "false", "off", "disabled"]);

const getOptionalConfigValue = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  const normalizedValue = value.trim();
  return DISABLED_VALUES.has(normalizedValue.toLowerCase())
    ? ""
    : normalizedValue;
};

export const getRecaptchaSiteKey = () =>
  getOptionalConfigValue(process.env.REACT_APP_RECAPTCHA_SITE_KEY);
